'use client'

import {ResendButton} from "@/components/Auth/VerifyEmailModal/VerifyEmailModal.styled";
import {useResendEmailMutation} from "@/store/api/v1/auth";
import {useCallback} from "react";
import {useTranslations} from "next-intl";

const ResendCodeButton = () => {
    const [ resendEmail, { isLoading, isSuccess, isError } ] = useResendEmailMutation()
    const t = useTranslations('Auth.SignUpForm.VerifyEmail')
    const tm = useTranslations('Main')

    const handleResendCode = useCallback(async () => {
        try {
            await resendEmail().unwrap()
        } catch (error) {
            console.log("Failed to resend email:", error)
        }
    }, [])

    return (
        <div>
            <ResendButton type={"button"} onClick={handleResendCode} disabled={isLoading}>
                {isLoading ? tm('sending') : t('resend_code')}
            </ResendButton>
            {isSuccess && <p>{t('email_resend_successful')}</p>}
            {isError && <p>{t('failed_message')}</p>}
        </div>
    )
};

export default ResendCodeButton;